import React from "react";
import { CTBRetest } from "../../../utils/api/endpoints/retests/parseRetests";
import RetestCard from "./RetestCard";

interface RetestCardGridProps {
  retests: CTBRetest[];
  onCardClick: (retest: CTBRetest) => void;
}

const RetestCardGrid: React.FC<RetestCardGridProps> = ({ retests, onCardClick }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {retests.map((retest) => (
        <RetestCard
          key={retest.retest_id}
          retest={retest}
          onClick={() => onCardClick(retest)}
        />
      ))}
    </div>
  );
};

export default RetestCardGrid;
